import { APIService } from 'connectors/api/rest';

export const Companies = {
  async getList(params) {
    try {
      return await APIService.GET('companies', params);
    } catch (e) {
      return null;
    }
  },
};
